<template>
  <div>
    <v-dialog
      v-model="showcampaigncard"
      :overlay-opacity="opacity"
      content-class="overlay-con"
      :persistent="true"
    >
      <div class="view-campaign-card">
        <div v-if="!showBanners">
          <div class="flex header">
            <div class="flex">
              <v-icon
                @click="closeOverlay"
                class="icon"
                color="#1F8F58"
                size="25"
              >
                mdi-arrow-left
              </v-icon>
              <h3 class="header-text">
                {{ campaign.campaign_name }}
              </h3>
            </div>

            <v-btn
              @click="handleCreateNewbtn"
              large
              class="createbtn"
              elevation="0"
              color="#1D8D56"
            >
              + Create New
            </v-btn>
          </div>

          <!-- current campaign images  -->
          <div
            v-if="campaign.campaign_post && campaign.campaign_post.length > 0"
            class="flex"
            style="justify-content: space-between"
          >
            <div class="campaign-con flex">
                <div class="flex" style="flex-direction:column" v-if="campaign.campaign_post.length >= 1">
                   <div><img
                  
                    @click="handleImgclick(campaign.campaign_post[0])"
                    :src="
                      campaign.campaign_post[0].video
                        ? campaign.campaign_post[0].video.image.medium
                        : campaign.campaign_post[0].image
                    "
                    style="margin-right: 10px"
                  /></div> 
                  <div>
                    <v-btn
                    style="margin-top: 5px; width: 270px"
                    small
                    elevation="0"
                    @click="generateDeeplink(campaign.campaign_post[0].id)"
                    color="#f4f9f5"
                    >Copy Deep Link
                    <v-icon class="ml-2" size="19">
                      mdi-checkbox-multiple-blank-outline
                    </v-icon></v-btn
                  >
                  </div>
                 
                  
                </div>
                <div  v-if="campaign.campaign_post.length >= 2">
                    <img
               
                @click="handleImgclick(campaign.campaign_post[1])"
                :src="
                  campaign.campaign_post[1].video
                    ? campaign.campaign_post[1].video.image.medium
                    : campaign.campaign_post[1].image
                "
              />
              <v-btn
              style="margin-top: 5px; width: 270px"
              small
              elevation="0"
              @click="generateDeeplink(campaign.campaign_post[1].id)"
              color="#f4f9f5"
              >Copy Deep Link
              <v-icon class="ml-2" size="19">
                mdi-checkbox-multiple-blank-outline
              </v-icon></v-btn
            >
                </div>
              
            </div>
            <div
              v-if="
                campaign.campaign_post && campaign.campaign_post.length >= 3
              "
              @click="showBanners = true"
              class="moreposts-btn"
            >
              <p>+ {{ campaign.campaign_post.length - 2 }} more posts</p>
            </div>
          </div>

          <!-- carousal for first two images -->
          <v-overlay :value="showCarouselOfTwoImage" opacity="0">
            <div class="view-carousal-of-TwoImage">
              <template v-if="showCarouselOfTwoImage">
                <div>
                  <div class="flex header">
                    <div class="flex">
                      <v-icon
                        @click="showCarouselOfTwoImage = false"
                        class="icon"
                        color="#1F8F58"
                        size="25"
                      >
                        mdi-arrow-left
                      </v-icon>
                    </div>
                  </div>
                </div>
                <div class="bigImg-con">
                  <img :src="selectedImage" />
                </div>
              </template>
            </div>
          </v-overlay>

          <!-- campaign analytics part -->
          <div class="campaign-nums flex">
            <div class="campaign-items">
              <label>
                <div class="label">Campaign progress %</div>
              </label>
              <div class="flex">
                <v-progress-linear
                  style="margin-bottom: 17px"
                  class="progree-bar"
                  :value="campaign.campaign_progress"
                  color="#1D8D56"
                  height="8"
                  :rounded="true"
                ></v-progress-linear>
                <p>{{ campaign.campaign_progress }}</p>
              </div>
            </div>

            <div class="campaign-items">
              <label>
                <div class="label">Calculated CPM</div>
              </label>
              <p class="--font">{{ campaign.calculated_cpm }}</p>
            </div>

            <div class="campaign-items">
              <label>
                <div class="label">Revenue achieved</div>
              </label>
              <p v-if="campaign.revenue_achieved" class="--font">
                {{ campaign.revenue_achieved }}
              </p>
              <p v-else>-</p>
            </div>
          </div>

          <!-- campaign analytics number  -->
          <div class="campaign-analytics flex">
            <div class="flex column1">
              <div class="flex numrow">
                <p style="margin-right: 40px">Total expected revenue</p>
                <p>{{ campaign.total_expected_revenue }}</p>
              </div>
              <div class="flex numrow">
                <p style="margin-right: 40px">No. of posts</p>
                <p>
                  {{
                    campaign.campaign_active_post_count +
                    campaign.campaign_paused_post_count +
                    campaign.campaign_inactive_post_count
                  }}
                </p>
              </div>
              <div class="flex numrow">
                <p style="margin-right: 40px">Target</p>
                <p>{{ campaign.target_count }}</p>
              </div>
            </div>
            <div class="flex column1">
              <div class="flex numrow">
                <p style="margin-right: 40px">Total impressions</p>
                <p>{{ campaign.total_campaign_impressions }}</p>
              </div>
              <div class="flex numrow">
                <p style="margin-right: 40px">Unique users</p>
                <p>{{ campaign.unique_users }}</p>
              </div>
              <div class="flex numrow">
                <p style="margin-right: 40px">Target predictor</p>

                <div class="flex">
                  <v-progress-linear
                    style="margin-bottom: 8px"
                    class="progree-bar"
                    :value="campaign.target_predictor"
                    color="#1D8D56"
                    height="8"
                    :rounded="true"
                  ></v-progress-linear>
                  <p>{{ campaign.target_predictor }}</p>
                </div>
              </div>
            </div>
          </div>
          <!-- button section  -->
          <div class="button-section flex">
            <v-btn
              v-if="campaign.is_paused"
              elevation="0"
              class="resume-btn"
              color="#F4F9F5"
              @click="handlePauseClick(campaign.id, false)"
            >
              Resume
            </v-btn>
            <v-btn
              v-else
              class="pause-btn"
              color="#FCEFF0"
              elevation="0"
              @click="handlePauseClick(campaign.id, true)"
            >
              Pause
            </v-btn>
            <v-btn
              @click="editCampaignClick(campaign.id)"
              elevation="0"
              class="edit-btn"
              color="#1D8D56"
            >
              Edit Campaign
            </v-btn>
          </div>
        </div>

        <!-- banner of current campagin posts -->
        <div v-if="showBanners">
          <div v-if="!showCarousel">
            <div class="flex" style="justify-content: flex-start">
              <v-icon
                class="icon"
                color="#1F8F58"
                size="25"
                @click="showBanners = false"
              >
                mdi-arrow-left
              </v-icon>
              <h3 class="header-text">Campaign v1.0</h3>
            </div>

            <div class="banners-con flex">
              <div v-for="(item, i) in campaign.campaign_post" :key="i">
                <div class="product-card flex">
                  <img
                    @click="showCarousel = true"
                    :src="item.video ? item.video.image.medium : item.image"
                    alt=""
                  />
                  <div>
                    <v-btn
                      style="margin-top: 5px; width: 240px"
                      small
                      elevation="0"
                      @click="generateDeeplink(item.id)"
                      color="#f4f9f5"
                      >Copy Deep Link
                      <v-icon class="ml-2" size="19">
                        mdi-checkbox-multiple-blank-outline
                      </v-icon></v-btn
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- open large image preview with carousel  -->
          <template v-if="showCarousel">
            <div>
              <v-icon
                @click="showCarousel = false"
                class="icon"
                color="#1F8F58"
                size="25"
              >
                mdi-close
              </v-icon>
            </div>
            <div class="carousel-con">
              <v-carousel :hide-delimiters="true">
                <v-carousel-item
                  v-for="(item, i) in campaign.campaign_post"
                  :key="i"
                  reverse-transition="fade-transition"
                  transition="fade-transition"
                >
                  <img
                    :src="item.video ? item.video.image.medium : item.image"
                  />
                </v-carousel-item>
              </v-carousel>
            </div>
          </template>
        </div>
      </div>
    </v-dialog>

    <!-- edit campaign called (create campaign form) -->
    <div v-if="createCampaignOverlay">
      <create-campaign
        :isEditCampaign="editCampaignClicked"
        :opacity="0"
        :campaignId="campaignId"
        :createCampaignOverlay="createCampaignOverlay"
        @closeCreateCampaignOverlay="closeCreateCampaignOverlay"
        @reloadApi="reloadApi"
      />
    </div>

    <success-page
      :type="successType"
      :successOverlay="successOverlay"
      @closeAll="reloadApi"
    />
  </div>
</template>

<script>
import createCampaign from "./create-campaign.vue";
import successPage from "./success-page.vue";
import accessToken from "../../../../helpers/accessToken";
import API_URL from "../../../../helpers/apiUrls";
export default {
  name: "viewcampaign",
  data() {
    return {
      opacity: 0.8,
      progress: 30,
      showanalytics: false,
      showOverlay: this.showcampaigncard,
      showBanners: false,
      createCampaignOverlay: false,
      successOverlay: false,
      showCarousel: false,
      showCarouselOfTwoImage: false,

      editCampaignClicked: false,
      createNewClicked: false,
      campaignId: "",
      successType: "",
      selectedImage: "",

      items: [
        {
          src: require("../../../../../temp/assets/temp.jpeg"),
        },
        {
          src: require("../../../../assets/post.svg"),
        },
        {
          src: require("../../../../assets/productImage.svg"),
        },
        {
          src: "https://cdn.vuetifyjs.com/images/carousel/bird.jpg",
        },
        {
          src: "https://cdn.vuetifyjs.com/images/carousel/planet.jpg",
        },
      ],
    };
  },

  props: {
    showcampaigncard: Boolean,
    campaign: Object,
  },
  methods: {
    // set selected image for preview
    handleImgclick(image) {
      var tempImage = image.video ? image.video.image.medium : image.image;

      this.selectedImage = tempImage;
      this.showCarouselOfTwoImage = true;
    },

    // toggle the status of campaign open sucess page on 200
    handlePauseClick(id, pauseStatus) {
      const successHandler = (response) => {
        if (response.status === 200) {
          if (this.campaign.is_paused) {
            this.successType = "resumed";
          } else if (!this.campaign.is_paused) this.successType = "paused";

          this.successOverlay = true;
        }
      };
      const errorHandler = (response) => {
        this.showToast("Something went wrong internally!", "error", 10000);
      };

      const headers = {
        Authorization: `Bearer ${accessToken.getAccessToken()}`,
      };
      this.requestGET(
        `${API_URL.pauseCampaign}?campaign_id=${id}&is_paused=${pauseStatus}`,
        {},
        headers,
        successHandler,
        errorHandler
      );
    },

    // handle edit and create new btn clicked
    editCampaignClick(id) {
      console.log("ID ---->", id);
      this.campaignId = id;
      this.editCampaignClicked = true;
      this.createCampaignOverlay = true;
    },
    handleCreateNewbtn() {
      this.editCampaignClicked = false;
      this.createCampaignOverlay = true;
    },
    reloadApi() {
      this.$emit("reloadApi");
    },
    closeOverlay() {
      this.$emit("closeoverlay");
    },
    closeCreateCampaignOverlay() {
      this.createCampaignOverlay = false;
    },
    generateDeeplink(item) {
      console.log(item);
      this.getOrGenerateDeeplinkApiCall(item);
    },
    getOrGenerateDeeplinkApiCall(postId) {
      const successHandler = (response) => {
        if (response.status === 200) {
            console.log(response.data.url);
            navigator.clipboard.writeText(response.data.url);
            this.showToast("Deeplink Copied !", "success", 10000);
        }
      };
      const data = {
        content_id: postId,
        content_type: "clips",
      };
      const errorHandler = (response) => {
        this.showToast("Something went wrong internally!", "error", 10000);
      };

      const headers = {
        Authorization: `Bearer ${accessToken.getAccessToken()}`,
      };
      this.requestPOST(
        `${API_URL.deeplink}`,
        data,
        headers,
        successHandler,
        errorHandler
      );
    },
  },
  components: {
    "create-campaign": createCampaign,
    "success-page": successPage,
  },
};
</script>

<style lang="scss" scoped>
.view-campaign-card {
  background-color: #ffffff;
  border-radius: 8px;
  padding: 10px;
  height: 630px;
  overflow: scroll;
}
.header {
  justify-content: space-between;
  margin-bottom: 25px;
}
.icon {
  background-color: #eff6f3;
  padding: 8px;
  border-radius: 6px;
}
.header-text {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 1.2rem;
  color: #333333;
  margin-left: 15px;
}

.createbtn {
  color: #fff !important;
  height: 44px !important;
  border-radius: 8px;
  cursor: pointer;
  margin-left: 10px;
  text-transform: capitalize !important;
  font-size: 15px !important;
  font-weight: 500;
}

.campaign-con {
  justify-content: space-between;

  img {
    width: 270px;
    max-width: 270px;
    height: 180px;
  }
}
.moreposts-btn {
  width: 180px;
  height: 100px;
  padding: 0px 30px;
  background-color: #f4f9f5;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  p {
    color: #1d8d56;
    font-size: 1.1rem;
    font-weight: 500;
    text-decoration: underline;
  }
}

.progree-bar {
  border-radius: 5px;
  margin-right: 10px;
  min-width: 100px;
}
.campaign-nums {
  justify-content: space-around;
  margin: 10px 0px;
}
.campaign-items {
  text-align: center;
  justify-content: flex-start;
  column-gap: 2px;
  p {
    font-size: 0.9rem;
    color: #333333;
  }
}

.label {
  color: #333333;
  font-size: 1.1rem;
  margin-bottom: 6px;
  font-weight: 500;
}
.carousel-con {
  margin-top: 40px;

  img {
    object-fit: contain;
    height: auto;
    max-height: 100%;
    width: 100%;
  }
}
.bigImg-con {
  margin-top: 40px;
  img {
    object-fit: contain;
    height: auto;
    max-height: 500px;
    width: 100%;
    width: 740px;
  }
}
.campaign-analytics {
  width: 100%;
  background-color: #eff6f3;
  border: 0.5px solid #1d8d56;
  border-radius: 5px;
  justify-content: space-between;
  padding: 20px 20px 12px;
}
.button-section {
  justify-content: space-between;
  margin-top: 30px;
  .v-btn {
    width: 45%;
    height: 56px !important;
    text-transform: capitalize !important;
    font-size: 1rem;
  }
}
.pause-btn {
  color: #de5d64 !important;
}
.resume-btn {
  color: #1d8d56 !important;
}
.edit-btn {
  color: #ffffff !important;
}
.column1 {
  flex-direction: column;
  align-items: flex-start;
}
.numrow {
  width: 100%;
  justify-content: space-between;

  p {
    margin-bottom: 12px;
    color: #333333;
  }
}
.banners-con {
  display: flex;
  flex-direction: row;
  width: 100%;
  flex-wrap: wrap;
  gap: 15px;
  justify-content: flex-start;

  margin-top: 20px;
  height: 530px;

  overflow-y: scroll;
  overflow-x: hidden;
  align-content: flex-start;
  img {
    width: 240px;
  }
}

.product-card {
  flex-direction: column;
  width: 100%;
  // min-height: 80px;
  padding: 0px 0px 0px 0px;

  img {
    height: 180px;
  }
}
.view-carousal-of-TwoImage {
  background-color: #ffffff;
  width: 800px;
  border-radius: 8px;
  padding: 30px;
  height: 650px;
}
::-webkit-scrollbar {
  width: 8px;
}
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: rgba(50, 52, 65, 0.4);
  border: 2px solid transparent;
  background-clip: content-box;
}
::-webkit-scrollbar-track {
  display: none;
}
::-webkit-scrollbar-corner {
  display: none;
  height: 0px;
  width: 0px;
}
</style>

<style>
.overlay-con.v-dialog {
  width: 800px;
  height: 650px;
  background-color: white;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: none;
}
</style>